var map = {
	"./2018-05-darknet/video.mp4": 302,
	"./2018-09-das-steckt-drin/video.mp4": 303,
	"./2019-02-abend-kompakt/video.mp4": 304,
	"./2019-02-quiz-geldwaescherei/video.mp4": 305,
	"./2019-03-staedtequiz/video.mp4": 306,
	"./2019-04-zuercher-laufrouten/video.mp4": 307,
	"./2019-07-klimazukunft/video.mp4": 308,
	"./2019-08-5g-faktencheck/alt/video.mp4": 309,
	"./2019-08-5g-faktencheck/video.mp4": 310,
	"./2019-09-sommerbilanz/video.mp4": 311,
	"./2019-10-prognose-staenderatswahlen/video.mp4": 312,
	"./2019-12-schneetage/video.mp4": 313,
	"./2020-02-lohnvergleich/video.mp4": 314,
	"./2020-02-winterbilanz/winterbilanz.mp4": 315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 301;